import { BaseAddress } from "../../config";
import performRequest from "../../utils/requestHelpers";
import { SCHOOLS_API } from "./constants";

const BASE = BaseAddress.CcAdmin;

const toJson = (r) => (r && typeof r.json === "function" ? r.json() : r);

async function realGet(path, params) {
  const qs = params
    ? "?" +
      new URLSearchParams(
        Object.entries(params).filter(([, v]) => v != null && v !== ""),
      ).toString()
    : "";
  const raw = await performRequest(`${BASE}${SCHOOLS_API}${path}${qs}`);
  return toJson(raw);
}

export async function fetchMeta() {
  return realGet("/meta");
}

/** @param {{shift?:string, lang?:string, status?:string}} filters */
export async function fetchDashboard(filters = {}) {
  return realGet("/dashboard", {
    shift: filters.shift,
    lang: filters.lang,
    status: filters.status,
  });
}

export async function downloadExport(format, state) {
  const p = new URLSearchParams({ format, locale: state.locale });
  if (state.shift) p.set("shift", state.shift);
  if (state.lang) p.set("lang", state.lang);
  if (state.status) p.set("status", state.status);

  const token = localStorage.getItem("token");
  const res = await fetch(`${BASE}${SCHOOLS_API}/export?${p.toString()}`, {
    credentials: "include",
    headers: token ? { Authorization: "Bearer " + token } : {},
  });
  if (!res.ok) throw new Error("export_failed");

  const blob = await res.blob();
  const objUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objUrl;
  a.download = `svod.${format}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(objUrl);
}
